import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Image } from 'antd';
import Modal from 'components/Modal';
import styled from 'styled-components';
import CustomVideoPlayer from './components/CustomVideoPlayer';
import { INotification } from 'features/user/services/types/notification';

export interface INotificationModalRef {
  open: (data: INotification) => void;
}

export const notificationModalRef = React.createRef<INotificationModalRef>();

export const useNotificationModal = () => {
  const open = (data: INotification) => {
    notificationModalRef.current?.open(data);
  };

  return {
    open,
  };
};

const NotificationModal = forwardRef<INotificationModalRef>((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<INotification>();

  useImperativeHandle(ref, () => ({
    open: (data: INotification) => {
      setVisible(true);
      setData(data);
    },
  }));

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <Modal
      visible={visible}
      // v2
      onClose={handleClose}
      modalTitle='Notification System'
      centered
      width={1440}
      destroyOnClose={true}
      noneBodyStyle
      hiddenOkButton
    >
      <Container>
        {data?.contentType === 'CONTENT' && <TrunkText dangerouslySetInnerHTML={{ __html: data.content }} />}
        {data?.contentType === 'VIDEO' && <CustomVideoPlayer src={data.content} />}
        {data?.contentType === 'IMAGE' && <Image src={data.content} preview={false} height={765} />}
      </Container>
    </Modal>
  );
});

NotificationModal.displayName = 'NotificationModal';

export default NotificationModal;

const Container = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const TrunkText = styled.div`
  color: #1d2129;
  font-family: Poppins;
  line-height: normal;
  font-size: 18px;
`;
